import styled from 'styled-components';
import FormRC from 'rc-field-form';

export const Form = styled(FormRC)`
  height: 100%;

  /* global override */
  max-height: unset !important;
  overflow: unset !important;
`;
